import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { catchError, filter, map } from 'rxjs/operators'
import { DomSanitizer } from '@angular/platform-browser'
import { XorService } from '@adex/shared/services/xor.service'
import { of } from 'rxjs'


const urlWhiteList = [
  'sandbox.cardpay.com',
  'cardpay.com'
]

@Component({
  selector: 'adex-iframe-container',
  templateUrl: './iframe-container.component.html',
  styleUrls: [ './iframe-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IframeContainerComponent {

  public isLoad = true
  public readonly url$ = this.route.queryParams.pipe(
    map(params => params.url || ''),
    map(url => this.xor.decode(url)),
    filter(url => urlWhiteList.includes(new URL(url).host)),
    catchError(err => {
      console.warn(err)
      return of('')
    }),
    map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url)),
  )

  constructor(private readonly route: ActivatedRoute, private readonly sanitizer: DomSanitizer, private readonly xor: XorService) {
  }

  public onLoad() {
    this.isLoad = false
  }

}
